import { useContext, useMemo, useState } from "react";
import { Position } from "reactflow";
import ServiceCallIcon from "../../assets/images/serviceCallIcon.svg";
import NodeContext from "../../context/NodeContext";
import {
  ActionButtonContainer,
  ServiceCallNode as StyledServiceCallNode,
} from "./ServiceCallNode.styled";
import DeleteIconImg from "../../assets/images/deleteIcon.svg";
import AddIconRed from "../../assets/images/addIconRed.svg";
import AddIconGreen from "../../assets/images/addIconGreen.svg";
import AddNodeSelector from "../../components/AddNodeSelector";
import { BottomEdge, TopEdge } from "../StartingNode/StartingNode.styled";
import { Button } from "../../components/ui/button";

function ServiceCallNode(props) {
  const { id, data } = props;
  const { titleText, isTop, isBottom, active } = data;
  const { handleNodeClick, edges, deleteNode, selectedNodeInfo, isEditable, isSuperAdmin, setSuperAdminModalVisibility } =
    useContext(NodeContext);
  const [showAddBox, setShowAddBox] = useState(false);
  const [sourceHandle, setSourceHandle] = useState(null);
  const [visible, setVisible] = useState(false);

  const isSuccessEdgeConnected = useMemo(
    () =>
      edges.findIndex(
        (edge) => edge.source === id && edge.sourceHandle === "bottom-success"
      ) !== -1,
    [edges, id]
  );

  const isFailureEdgeConnected = useMemo(
    () =>
      edges.findIndex(
        (edge) => edge.source === id && edge.sourceHandle === "bottom-failure"
      ) !== -1,
    [edges, id]
  );

  return (
    <>
      {isTop ? (
        <TopEdge
          type="target"
          position={Position.Top}
          id="top"
          isConnectable={true}
          iseditable={(isEditable) ? "true" : undefined}
        />
      ) : null}

      <StyledServiceCallNode
        $isActive={active ? active : selectedNodeInfo?.id === id}
        onClick={() => handleNodeClick(id)}
      >
        <div className="titleContainer">
          <img src={ServiceCallIcon} alt="serviceCallNodeIcon" />
          <span className="titleText">{titleText}</span>
        </div>

        {(isEditable) && (
          <ActionButtonContainer
            className="action-btns"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={DeleteIconImg}
              alt="deleteIcon"
              onClick={() => {
                // deleteNode(id);
                setVisible(true);
              }}
            />
          </ActionButtonContainer>
        )}
        {(isEditable) && visible && (
          <ActionButtonContainer
            className="action-btns"
            onClick={(e) => e.stopPropagation()}
            style={{
              right: "-315px",
              top: "-35px",
              height: "auto",
              width: "250px",
              padding: "10px",
            }}
          >
            <span
              style={{
                fontSize: "16px",
                fontWeight: "bold",
                fontFamily: "Plus Jakarta Sans, sans-serif",
                marginBottom: "10px",
                color: "#000",
              }}
            >
              Are you sure you want to delete?
            </span>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "150px",
                margin: "auto",
                padding: "10px 8px",
                gap: "20px",
              }}
            >
              <Button
                variant="outline"
                className="rounded-[5px] px-[10px] py-[5px] h-auto border-[#007372] text-[#007372] hover:bg-teal-50 hover:text-[#007372] hover:border-[#007372]"
                onClick={(e) => {
                  e.stopPropagation();
                  setVisible(false);
                }}
              >
                Cancel
              </Button>
              <Button
                variant="outline"
                className="rounded-[5px] px-[10px] py-[5px] h-auto border-[#ef4949] text-[#ef4949] hover:bg-red-50 hover:text-[#ef4949] hover:border-[#ef4949]"
                onClick={() => {
                  setVisible(false);
                  if (!isSuperAdmin) {
                    setSuperAdminModalVisibility({
                      visible: true,
                      id: id,
                    });
                  } else {
                    deleteNode(id);
                  }
                }}
              >
                Delete
              </Button>
            </div>
          </ActionButtonContainer>
        )}
        {/* 
                {!isSuccessEdgeConnected ? (
                    <AddIcon
                        className="addIcon success"
                        onClick={(e) => {
                            e.stopPropagation();
                            setShowAddBox(!showAddBox);
                            setSourceHandle("bottom-success");
                        }}
                    />
                ) : null}

                {!isFailureEdgeConnected ? (
                    <AddIcon
                        className="addIcon failure"
                        onClick={(e) => {
                            e.stopPropagation();
                            setShowAddBox(!showAddBox);
                            setSourceHandle("bottom-failure");
                        }}
                    />
                ) : null} */}

        {showAddBox ? (
          <AddNodeSelector
            nodeData={{
              ...props,
              sourcePosition: sourceHandle
                ? sourceHandle
                : props.sourcePosition,
              xPos: sourceHandle
                ? sourceHandle === "bottom-success"
                  ? props?.xPos - 150
                  : props?.xPos + 150
                : props?.xPos,
            }}
            setShowAddBox={setShowAddBox}
          />
        ) : null}
      </StyledServiceCallNode>

      {isBottom ? (
        <BottomEdge
          type="source"
          position={Position.Bottom}
          id="bottom-success"
          isConnectable={!isSuccessEdgeConnected}
          style={{ left: "30%", transform: "translateX(-50%)" }}
          onClick={(e) => {
            e.stopPropagation();
            handleNodeClick(id);
            setShowAddBox(!showAddBox);
            setSourceHandle("bottom-success");
          }}
          iseditable={isEditable ? "true" : undefined}
          bgcolor="#00c53d"
          $addIcon={AddIconGreen}
          $handleColor="#00c53d11"
        />
      ) : null}

      {isBottom ? (
        <BottomEdge
          type="source"
          position={Position.Bottom}
          id="bottom-failure"
          isConnectable={!isFailureEdgeConnected}
          style={{ left: "70%", transform: "translateX(-50%)" }}
          $addIcon={AddIconRed}
          $handleColor="#ec0000"
          onClick={(e) => {
            e.stopPropagation();
            handleNodeClick(id);
            setShowAddBox(!showAddBox);
            setSourceHandle("bottom-failure");
          }}
          iseditable={isEditable ? "true" : undefined}
          bgcolor="#ef4949"
        />
      ) : null}
    </>
  );
}

export default ServiceCallNode;
